<template>
  <router-view class="forgot-password"/>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions([
      'clearRecoverData',
    ]),
  },
  beforeRouteLeave(from, to, next) {
    this.clearRecoverData();
    next();
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.forgot-password
  max-width: 350px
  +media-min-sm()
    max-width: none
  +media-min-md()
  +media-min-lg()
</style>
